import { MONTH_ABBR_PT } from '@practium/shared';
import type { FloraAIChat, FloraAIChatGroup } from '../types/flora-ai.types';

const isSameDay = (a: Date, b: Date) =>
	a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const formatFloraChatTimestamp = (timestamp: Date, now: Date = new Date()) => {
	if (isSameDay(timestamp, now)) return 'agora';

	const yesterday = new Date(now);
	yesterday.setDate(now.getDate() - 1);
	if (isSameDay(timestamp, yesterday)) return 'ontem';

	return `${timestamp.getDate()} ${MONTH_ABBR_PT[timestamp.getMonth()].toLowerCase()}`;
};

export const groupFloraChatsByDate = (chats: FloraAIChat[], now: Date = new Date()): FloraAIChatGroup[] => {
	const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const sevenDaysAgo = new Date(startOfToday);
	sevenDaysAgo.setDate(startOfToday.getDate() - 7);

	const today: FloraAIChat[] = [];
	const lastWeek: FloraAIChat[] = [];
	const older: FloraAIChat[] = [];

	for (const chat of chats) {
		if (chat.timestamp >= startOfToday) {
			today.push(chat);
		} else if (chat.timestamp >= sevenDaysAgo) {
			lastWeek.push(chat);
		} else {
			older.push(chat);
		}
	}

	return [
		{ label: 'Hoje', chats: today },
		{ label: 'Últimos 7 dias', chats: lastWeek },
		{ label: 'Anteriores', chats: older },
	].filter((group) => group.chats.length > 0);
};
